import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react/components/Loading/Loading';

function DriverAssignmentItem({ assignment, driverCanBeRemoved, unassignDriver }) {
  const [isLoading, setIsLoading] = useState(false);

  const { driver } = useMemo(() => assignment, [assignment]);

  function handleUnassignDriver() {
    setIsLoading(true);

    unassignDriver(
      assignment,
      () => {
        setIsLoading(false);
      },
      () => {
        setIsLoading(false);
      }
    );
  }

  const rightIcon = useMemo(() => {
    if (driverCanBeRemoved && !isLoading) {
      return (
        <button
          type="button"
          data-testid={`driver-${driver.key}-remove-icon-button`}
          onClick={handleUnassignDriver}
          className="remove-icon"
        />
      );
    }
    if (isLoading) {
      return <Loading width="20px" height="20px" />;
    }
    return null;
  }, [driverCanBeRemoved, isLoading]);

  return (
    <div data-testid={`driver-assignment-${driver.key}`} className="driver-assigned">
      <div className="driver-name">
        <p>{`${driver.key} - ${driver.name}`}</p>
      </div>
      {rightIcon}
    </div>
  );
}

DriverAssignmentItem.propTypes = {
  assignment: PropTypes.shape({
    driver: PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  driverCanBeRemoved: PropTypes.bool.isRequired,
  unassignDriver: PropTypes.func.isRequired
};

export default DriverAssignmentItem;
